import { ComponentInteractionEnum } from 'enums/ComponentInteractionEnum';
import { jsonProperty, Serializable, SerializationSettings } from 'ts-serializable';
import ComponentSanfonaModel from './ComponentSanfona';
import ComponentQuizModel from './ComponentQuiz';
import CorrespondentModel from './CorrespondentModel';
import ComponentCarrosselInteraction from './ComponentCarrosselInterarion';
import ComponentAbasModel from './ComponentAbas';
import ComponentBaralhoModel from './ComponentBaralho';
import ComponentReguaAvaliativaModel from './ComponenteReguaAvaliativa';
import ComponentTimeLine from './ComponentTimeLine';
import ComponentQuizPontuacao from './ComponentQuizPontuacao';
import ComponentQuizPontuacaoGlobal from './ComponentQuizPontuacaoGlobal';
import { ComponentCenarioGlobal } from './ComponentCenarioGlobal';
import { ComponentInteractionAnexo } from './ComponentInteractionAnexo';
import { ComponentMark } from './ComponentMark';
import ComponentHostpotModel from './ComponentHostPot';
import { FadAvaliationsModel } from 'models/ferramentaAutoria/FadAvaliationsModel';
import ComponentInteractionClasse from './ComponentInteractionClasse';
import ComponentArrasteSolte from './ComponentArrasteSolte';
import ComponentGameMemory from './ComponentGameMemory';
import ComponentLacunas from './ComponentLacunas';
import ComponentCorrespondentImagem from './ComponentCorrespondentImagem';
import { json } from 'stream/consumers';
import { ComponentInteractionPositionEnum } from 'enums/ComponentInteractionPositionEnum';

interface ComponentInteractionJson {
    id: number;
    tipo: ComponentInteractionEnum;
    conteudo: string;
    conteudoTwo: string;
    cor: string;
    quantityVisible: number;
    ordem: number;
    obrigatory: boolean;
    codigoContent?: number;
    sanfona: ComponentSanfonaModel[] | null;
    quiz: ComponentQuizModel[] | null;
    correspondent: CorrespondentModel | null;
    carrossel: ComponentCarrosselInteraction | null;
    abas: ComponentAbasModel[] | null;
    baralho: ComponentBaralhoModel[] | null;
    reguaAvaliativa: ComponentReguaAvaliativaModel | null;
    timelines: ComponentTimeLine[] | null;
    quizPontuacao: ComponentQuizPontuacaoGlobal | null;
    cenarios: ComponentCenarioGlobal | null;
    hostpots: ComponentHostpotModel[] | null;
    arrasteSolte: ComponentArrasteSolte | null;
    gameMemorys: ComponentGameMemory[] | null;
    lacunas: ComponentLacunas | null;
    correspondentImagem: ComponentCorrespondentImagem | null;
    userAvaliation: FadAvaliationsModel | null;
    anexo: ComponentInteractionAnexo | null;
}

class ComponentInteractionModel extends Serializable {
    @jsonProperty(Number)
    id: number = -1;

    tipo: ComponentInteractionEnum = ComponentInteractionEnum.NENHUM;

    @jsonProperty(String)
    conteudo: string = '';

    @jsonProperty(String)
    conteudoTwo: string = '';

    @jsonProperty(Number)
    ordem: number = -1;

    @jsonProperty(Number)
    quantityVisible: number = -1;

    @jsonProperty(String, null)
    cor: string | null = null;

    @jsonProperty(Boolean, null)
    obrigatory: boolean | null = null;

    @jsonProperty(Number, null)
    sizeImgWidth: number | null = null;

    @jsonProperty(Number, null)
    sizeImgHeight: number | null = null;

    @jsonProperty(Boolean)
    customImg: boolean = false;

    positionImg: ComponentInteractionPositionEnum = ComponentInteractionPositionEnum.CENTER;

    @jsonProperty(Number, null)
    codigoContent: number | null = -1;

    classes: ComponentInteractionClasse[] | null = null;

    sanfona: ComponentSanfonaModel[] | null = null;

    quiz: ComponentQuizModel[] | null = null;

    correspondent: CorrespondentModel | null = null;

    abas: ComponentAbasModel[] | null = null;

    carrossel: ComponentCarrosselInteraction | null = null;

    baralho: ComponentBaralhoModel[] | null = null;

    reguaAvaliativa: ComponentReguaAvaliativaModel | null = null;

    timelines: ComponentTimeLine[] | null = null;

    quizPontuacao: ComponentQuizPontuacaoGlobal | null = null;

    cenarios: ComponentCenarioGlobal | null = null;

    marks: ComponentMark | null = null;

    hostpots: ComponentHostpotModel[] | null = null;

    arrasteSolte: ComponentArrasteSolte | null = null;

    gameMemorys: ComponentGameMemory[] | null = null;

    lacunas: ComponentLacunas | null = null;

    correspondentImagem: ComponentCorrespondentImagem | null = null;

    userAvaliation: FadAvaliationsModel | null = null;

    anexo: ComponentInteractionAnexo | null = null;

    fromJSON(json: ComponentInteractionJson, settings?: Partial<SerializationSettings>): this {
        this.id = json.id;
        this.tipo = json.tipo;
        this.conteudo = json.conteudo;
        this.conteudoTwo = json.conteudoTwo;
        this.cor = json.cor ?? null;
        this.quantityVisible = json.quantityVisible;
        this.ordem = json.ordem;
        this.codigoContent = json.codigoContent ?? null;
        this.obrigatory = json.obrigatory ?? null;
        this.sanfona = json.sanfona ?? null;
        this.quiz = json.quiz ?? null;
        this.correspondent = json.correspondent ?? null;
        this.carrossel = json.carrossel ?? null;
        this.abas = json.abas ?? null;
        this.baralho = json.baralho ?? null;
        this.reguaAvaliativa = json.reguaAvaliativa ?? null;
        this.timelines = json.timelines ?? null;
        this.quizPontuacao = json.quizPontuacao ?? null;
        this.cenarios = json.cenarios ?? null;
        this.hostpots = json.hostpots ?? null;
        this.arrasteSolte = json.arrasteSolte ?? null;
        this.gameMemorys = json.gameMemorys ?? null;
        this.lacunas = json.lacunas ?? null;
        this.correspondentImagem = json.correspondentImagem ?? null;
        this.userAvaliation = json.userAvaliation ?? null;
        this.anexo = json.anexo ?? null;
        return this;
    }
}

export default ComponentInteractionModel;
